import { FilterType } from '~types/filters'

export const getCountryNameByIso2 = (isoOrId: string, listOfCountries: FilterType[]) => {
  if (!isoOrId) {
    return undefined
  }
  const directMatch = listOfCountries.find((el) => el.value === isoOrId)?.label
  if (directMatch) {
    return directMatch
  }
  const fallbackMatch = listOfCountries.find(
    (el) => el.value?.toString?.().toUpperCase() === isoOrId.toUpperCase()
  )
  return fallbackMatch?.label
}
